import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { DEFAULT_EFFECTIVE_LOCALE } from './locale-context.service';

const DEFAULT_CURRENCY_INPUT_LOCALE = DEFAULT_EFFECTIVE_LOCALE;

const COUNTRY_CURRENCY_INPUT_LOCALE_MAP: Record<string, string> = {
  DE: 'de-DE',
  ES: 'es-ES',
  FR: 'fr-FR',
  NG: 'en-NG',
  US: 'en-US',
};

@Injectable({
  providedIn: 'root'
})
export class CurrencyInputLocaleService {
  private readonly localeSubject = new BehaviorSubject<string>(DEFAULT_CURRENCY_INPUT_LOCALE);
  readonly locale$: Observable<string> = this.localeSubject.asObservable();

  setTenantCountryCode(code: string | null | undefined): void {
    const normalizedCode = code?.trim().toUpperCase();
    const resolved = normalizedCode
      ? COUNTRY_CURRENCY_INPUT_LOCALE_MAP[normalizedCode] ?? DEFAULT_CURRENCY_INPUT_LOCALE
      : DEFAULT_CURRENCY_INPUT_LOCALE;
    this.localeSubject.next(resolved);
  }

  setEffectiveLocaleCode(localeCode: string | null | undefined): void {
    const requestedLocale = localeCode?.trim();
    if (!requestedLocale) {
      this.localeSubject.next(DEFAULT_CURRENCY_INPUT_LOCALE);
      return;
    }

    try {
      const supported = Intl.NumberFormat.supportedLocalesOf([requestedLocale]);
      this.localeSubject.next(supported.length > 0 ? requestedLocale : DEFAULT_CURRENCY_INPUT_LOCALE);
    } catch {
      this.localeSubject.next(DEFAULT_CURRENCY_INPUT_LOCALE);
    }
  }

  getLocale(): string {
    return this.localeSubject.getValue();
  }
}
